const graphql = (_) => {
  if (process.env.NODE_ENV !== "production") {
    throw new Error("graphql: Unexpected invocation at runtime. Either the Babel transform was not set up, or it failed to identify this call site. Make sure it is being used verbatim as `graphql`. Note also that there cannot be a space between graphql and the backtick that follows.");
  }
  return {};
};
class InvalidGraphqlRequest extends Error {
  constructor(message) {
    super(message);
    Object.setPrototypeOf(this, InvalidGraphqlRequest.prototype);
  }
}
export {
  InvalidGraphqlRequest,
  graphql
};
